<template>
  <div>
    <OnboardingIndex
      title="Forgot Password"
      submit_button_text="Send Reset Link"
      :verification_running="verification_running"
      :custom_submit_button="true"
      @custom-submit="send_reset_email"
    >
      <template v-slot:form-content>
        <div class="mx-auto w-100">
          <div class="mb-4">
            <label for="forgot_email" class="text-xs mb-2">Email Address</label>
            <input
              id="forgot_email"
              v-model="email"
              type="email"
              class="form-control form-control-sm text-xs bg-light border-0 py-2"
              placeholder="Enter Your Email Address"
              required
            />
          </div>

          <router-link
            :to="{ name: 'UserLogin' }"
            class="fw-semibold text-decoration-none small text-xs"
          >
            Back to Login
          </router-link>
        </div>
      </template>

      <template v-slot:custom-button>
        <div class="d-grid pt-1">
          <button
            type="submit"
            class="btn btn-primary-dark shadow w-100"
            :disabled="verification_running"
          >
            {{ verification_running ? 'Sending...' : 'Send Reset Link' }}
          </button>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>
